import React from "react";
import NavBar from "../NavBar";
import BICardRender from "./BICardRender";
import "./Business.css";
import { BICardUpData } from "./BICardData";
import PieChartCardRender from "../PieChartCardRender";
// import PiechartDnCardRender from '../PiechartDnCardRender'
// import DoubleLine from '../DoubleLine'
import SingleLineChart from "../SingleLineChart";
// import BarLineChart from "../BarLineChart";
import StackedBarChart from "../StackedBarChart";
import { BIColorData } from "../BarColorData";
import { BIBarData } from "../BarchartData";
import SingleRefLineChart from "../SingleRefLineChart";
import PieGraph from "./PieGraph";
import SalesBreakdown from "../SalesBreakdown";
import TopProducts from "../TopProducts";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { BILineData } from "../SingleLineChartData";
import { pieData } from "../BIData";
import DotsComponent from '../DotsComponent'
import PieCardRender from "../PieCardRender";
import CardRender from "../DashboardCardRender";
import { BICardData } from "../Dashboard card data";
import GraphLabel1 from "../Components/GraphLabel1";
const BIDashboard = () => {
  return (
    <div>
      <NavBar />
      <div>
        <p className="title">
          <span className="title_line"></span>
          <span className="business_title">Business Intelligence </span>
          <span className="color"> &#62; </span>
          <span className="color"> Dashboard</span>
        </p>
      </div>
      <div id="Right-content-Down-First">
        <h2>Dashboard</h2>
        <div id="Right-content-Down-Filters">
          <p>Till Now:</p>
          <label className="switch">
            <input type="checkbox" />
            <span className="slider"></span>
          </label>
          <div
            style={{
              "border-left": "1px solid rgba(128, 128, 128, 0.511)",
              height: "80%",
            }}
          ></div>
          <label htmlFor="Starting-month">Sort from:</label>
          <input type="date" id="Starting-month" />
          <label htmlFor="Ending-month">To:</label>
          <input type="date" placeholder="Ending month" id="Ending-month" />
          <div
            style={{
              "border-left": "5px dotted rgba(0, 0, 0, 0.989)",
              height: "60%",
            }}
          ></div>
        </div>
      </div>

      <div id="right-content-cards">
        <PieCardRender data={BICardData[0]} filling={fillingData1} pieColor={PIECOLORS1} pieIndicator={pieIndicator1}/>
        <PieCardRender data={BICardData[1]} filling={fillingData2} pieColor={PIECOLORS2} pieIndicator={pieIndicator2}/>
        <CardRender comp={BICardData.slice(2,6)} />
      </div>

      <div id="" className="Dashboard-graph-parent">
        <div className="dashboard-graph">
          <div className="graph">
            <DotsComponent/>
            <div className="graph_heading">
              <h1 className="Graph_title">TOTAL SALES</h1>
              <OpenInNewIcon
                style={{ fontSize: "16", marginLeft: "5" }}
              ></OpenInNewIcon>
            </div>
          </div>
          <GraphLabel1 color = {"#394A7E"} value={'Expense'}/>
          <SingleLineChart data={BILineData}/>
        </div>
        <div className="dashboard-graph">
          <SalesBreakdown data={pieData}/>
        </div>
      </div>
      <div id="right-content-cards">
        <BICardRender comp={BICardUpData} />
      </div>

      <div id="" className="Dashboard-graph-parent" style={{marginTop:"18px"}}>
        <div className="dashboard-graph">
        <DotsComponent/>
        <div className="chart-head">
              <h1 className="Graph_title">CART ABANDONMENT FREQUENCY OF USERS</h1>
              <OpenInNewIcon
                style={{ fontSize: "16", marginLeft: "5" }}
              ></OpenInNewIcon>
            </div>
          <PieGraph />
        </div>
        <div className="dashboard-graph">
          <div className="graph">
          <DotsComponent/>
            <div className="chart-head">
              <h1 className="Graph_title">TOP SUPPLIERS</h1>
              <OpenInNewIcon
                style={{ fontSize: "16", marginLeft: "5" }}
              ></OpenInNewIcon>
            </div>
          </div>
          <div
            className="graph_name G-name"
            style={{ marginLeft: "24px", width: "92%" }}
          >
            <span
              style={{ backgroundColor: "#394A7E" }}
              className="indicator"
            ></span>
            <h5 style={{ paddingLeft: "5px" }} className="ind-text">
              Supplier 1
            </h5>
            <span
              style={{ backgroundColor: "#4E6DCB" }}
              className="indicator"
            ></span>
            <h5 style={{ paddingLeft: "5px" }} className="ind-text">
              Supplier 2
            </h5>

            <span
              style={{ backgroundColor: "#20BF55" }}
              className="indicator"
            ></span>
            <h5 style={{ paddingLeft: "5px" }} className="ind-text">
              Supplier 3
            </h5>
          </div>
          <StackedBarChart BarData={BIBarData} ColorData={BIColorData}/>
        </div>
      </div>

      <div id="" className="Dashboard-graph-parent" style={{marginTop:"15px"}}>
        <div className="dashboard-graph">
          <TopProducts />
        </div>
        <div className="dashboard-graph">
          <SingleRefLineChart />
        </div>
      </div>
    </div>
  );
};

export default BIDashboard;
const fillingData1 = [
  { name: "Group A", value: 400 },
  { name: "Group B", value: 850 },
];
const PIECOLORS1 = ["#FFE754", "#F7762E", "#FFC700"];
const pieIndicator1 = ["#FFC700", "#F7762E"]

const fillingData2 = [
  { name: "Group A", value: 400 },
  { name: "Group B", value: 850 },
  { name: "Group C", value: 400 },

];
const PIECOLORS2 = ["#FFE754", "#F7762E", "#FFC700"];
const pieIndicator2 = []